import { render, staticRenderFns } from "./borrower.vue?vue&type=template&id=1d7300e4&"
import script from "./borrower.vue?vue&type=script&lang=js&"
export * from "./borrower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports